import { useTranslation } from "react-i18next";
import { buildTranslateEntityFn } from "../buildTranslateEntityFn";
import getNamespace from "../getNamespace";

/**
 * Custom hook for handling customer-specific translations.
 *
 * @returns {Object} An object containing:
 * - `tCustomer`: The translation function scoped to the customer defined namespace.
 * - `translateEntity`: A function to translate entities (e.g. `service`, `resource`, `category`).
 * - Other properties returned from `useTranslation`.
 *
 * This hook initializes the translation function using a dynamically determined namespace
 * and provides a utility for translating entities with structured keys.
 */
export default function useCustomerTranslation() {
  const namespace = getNamespace();
  const { t: tCustomer, ...rest } = useTranslation(namespace);
  return {
    tCustomer,
    translateEntity: buildTranslateEntityFn(tCustomer),
    ...rest,
  };
}
